
















































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { UserModule, CommonModule } from '../../store'
import { OperationItemType } from '../../types/type'
import { getAllFatherNodeForTree } from '../../utils/toolsForCommon'
@Component({
  name: 'OrganizationChart',
  components: {
    'concise-card-have-title-acquiescent': () => import('../../components/common/conciseCardHaveTitleAcquiescent.vue'),
    'my-dialog': () => import('../../components/common/myDialog.vue')
  }
})
export default class OrganizationChart extends Vue {
  public filterText: string = ''
  public defaultProps: any = {
    children: 'children',
    label: 'name'
  }
  public loading: boolean = true
  public dialogVisible: boolean = false
  public title: string = ''
  public isOnlyLook: boolean = false
  public name: string = ''
  public belongTo: any[] = []
  public typeOptions: any[] = [
    {
      label: '部门',
      value: '0'
    },
    {
      label: '学校',
      value: '1'
    }
  ]
  public type: number | string = ''
  public whoEditorId: any = ''
  public belongToOnDelete: any[] = []
  public dialogVisibleOnDelete: boolean = false
  public removeId: string | number = ''
  public whetherStatistic: boolean = false
  // 列头操作：
  public operationForButtonOfTableHeader: Array<OperationItemType> = [
    {
      title: "<span class='el-icon-circle-plus-outline m_r5'></span>新增组织",
      key: 'add',
      type: 'primary',
      size: '',
      icon: 'el-icon-circle-plus-outline'
    }
  ]

  get userInfoAuthority () {
    return UserModule.userInfo ? UserModule.userInfo.resultAuthorityList : []
  }

  get allRole () {
    let _that: any = this
    return _that.$RoleCode
  }

  get treeDataForOrganatizion () {
    return CommonModule.treeDataForOrganatizion
  }

  @Watch('filterText') filterTextChange (val: any) {
    ;(this.$refs.tree as any).filter(val)
  }

  created () {
    this.getTreeDataForOrganization()
  }

  filterNode (value: any, data: any) {
    if (!value) return true
    return data.name.indexOf(value) !== -1
  }

  handleAdd () {
    this.dialogVisible = true
    this.name = this.type = this.whoEditorId = ''
    this.belongTo = []
    this.whetherStatistic = false
    this.title = '新增组织架构'
  }

  editorNode (data) {
    this.dialogVisible = true
    this.name = data.name
    this.type = data.type
    this.whetherStatistic = data.whetherStatistic
    this.whoEditorId = data.id
    this.belongTo = getAllFatherNodeForTree(this.treeDataForOrganatizion, 'children', 'id', data.pid)
    this.title = '编辑组织架构'
  }

  async save () {
    try {
      if (!this.name) return this.$message.error('请输入组织架构名称')
      if (this.type === '') return this.$message.error('请选择类型')
      let _that: any = this
      let params = {
        name: this.name,
        pid: this.belongTo && this.belongTo.length ? this.belongTo[this.belongTo.length - 1] : 0,
        type: this.type,
        whetherStatistic: this.whetherStatistic
      }
      let message = '组织架构新增成功'
      if (this.whoEditorId) {
        message = '组织架构编辑成功'
        Object.assign(params, { id: this.whoEditorId })
      }
      let { data: result } = await _that.$http.organizationSaveOrUpdate(params)
      if (result.code !== 200) return this.$message.error(result.msg)
      this.$message.success(message)
      this.dialogVisible = false
      await this.getTreeDataForOrganization()
    } catch (err) {
      console.log(err)
    }
  }

  async handleSync () {
    try {
      let _that: any = this
      let { data: result } = await _that.$http.saveOrganizationToRedis()
      if (result.code !== 200) return this.$message.error(result.msg)
      this.$message.success('组织架构同步成功')
    } catch (err) {
      console.log(err)
    }
  }

  async getTreeDataForOrganization () {
    this.loading = true
    await CommonModule.getTreeDataForOrganization()
    this.loading = false
  }

  // 删除：
  removeNode (data) {
    this.removeId = data.id
    this.dialogVisibleOnDelete = true
  }

  delConfirm () {
    if (this.belongToOnDelete && this.belongToOnDelete.length === 0) return this.$message.warning('请选择节点')
    let params = {
      removeId: this.removeId,
      toId: this.belongToOnDelete[this.belongToOnDelete.length - 1]
    }
    this.delFun(params)
  }

  delFun (params) {
    this.$confirm('删除后无法恢复, 是否继续?', '提示', {
      confirmButtonText: '确定删除',
      cancelButtonText: '取消删除',
      type: 'error'
    })
      .then(() => this.deleteOne(params))
      .then(() => this.getTreeDataForOrganization())
      .then(() => {
        this.dialogVisibleOnDelete = false
        this.$message.success('组织架构删除成功')
      })
      .catch(() => {})
  }

  deleteOne (params) {
    return new Promise(async (resolve, reject) => {
      try {
        let _that: any = this
        let { data: result } = await _that.$http.organizationDelete(params)
        if (result.code !== 200) return this.$message.error(result.msg)
        this.belongToOnDelete = []
        resolve(true)
      } catch (err) {
        reject(err)
      }
    })
  }

  // 操作按钮：
  operationForButton ({ key }) {
    switch (key) {
      case 'add':
        this.handleAdd()
        break
    }
  }
}
